<template>
    <div class="select-popcomfirm-wrap nano border">
        <el-form label-width="100px">
            <el-form-item :label="item.k && item.k._name ? item.k._name: ''" v-for="(item, index) in valueList"
                          :key="item.k._name" :title="item.k._name">
                <el-cascader
                        v-if="item.k.columnItem==='catName.keyword' && isCascader"
                        v-model="item.value"
                        size="small"
                        :options="item.v"
                        :props="cascaderProps"
                        collapse-tags
                        clearable
                        @change="selectItem(item.value, item)"
                ></el-cascader>
                <el-select v-model="item.value"
                           v-else-if="item.k.columnItem !== 'published'"
                           :placeholder="'select' + item.k._name"
                           size="small"
                           filterable
                           allow-create
                           default-first-option
                           multiple
                           collapse-tags
                           @change="selectItem(item.value, item)"
                           clearable>
                    <el-option v-for="(ite, ind) in item.v" :key="ind"
                               :label="ite.value"
                               :value="ite.key"
                               :title="ite.value">
                    </el-option>
                </el-select>
                <time-range
                        v-else
                        :value.sync="item.value"
                        class="data-picker"
                        @change="selectItem(item.value, item)">
                </time-range>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import * as _ from 'lodash'
import TimeRange from './timeRange.vue'

export default {
  name: 'selectPopcomfirm',
  components: {
    TimeRange
  },
  props: {
    value: {
      type: Array
    },
    isCascader: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      filterArr: [], // 需要筛选的数组
      cascaderProps: {
        // checkStrictly: true,
        value: 'key',
        label: 'value',
        multiple: true
      }
    }
  },
  computed: {
    valueList () {
      return this.value
    }
  },
  methods: {
    // 外部调用情况数据
    clearMessage () {
      this.filterArr = []
    },
    deleteItem (val, pVal) {
      // debugger
      this.filterArr = _.filter(this.filterArr, (item) => {
        return item.k !== pVal.k.columnItem
      })
    },
    selectItem (_val, pVal) {
      let val = _.cloneDeep(_val)
      if (pVal.k.columnItem === 'catName.keyword') {
        // debugger
        const arr = []
        for (let item in val) {
          const o = val[item]
          let key = o
          if (typeof o === 'object') {
            key = o[o.length - 1]
          }
          arr.push(key)
        }
        val = arr
        console.log(arr)
      }
      if (val.length) {
        this.filterArr = _.filter(this.filterArr, (item) => {
          return item.k !== pVal.k.columnItem
        })
        const vals = {
          d: '0',
          k: pVal.k.columnItem,
          v: val
        }
        if (pVal.k.name === '时间') {
          // debugger
          vals.d = '1'
          vals.v = val
          this.filterArr = _.filter(this.filterArr, (item) => {
            return item.k !== vals.k
          })
        } else {
          vals.v = [val.join('╎')]
        }
        this.filterArr.push(vals)
      } else {
        this.filterArr = _.filter(this.filterArr, (item) => {
          return item.k !== pVal.k.columnItem
        })
      }
      this.$emit('selectItem', this.filterArr)
    }
  }
}
</script>

<style scoped lang="less">
    // @media screen and(max-width: 1400px) {
    //     .el-form-item {
    //         width: 100% !important;
    //     }
    // }


    .nano-content {
        padding-top: 6px !important;
    }

    .select-popcomfirm-wrap {
        width: 100%;
        height: 100%;
        background: #ffffff;
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);

        .el-form {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            padding: 5px 0 0 0;
        }

        .el-form-item {
            width: 100%;
            margin-bottom: 0px;

            .el-select, .el-cascader {
                /*min-width: 150px;*/
                /*max-width: 230px;*/
                width: calc(95% - 15px) !important;
            }

            .el-date-editor {
                width: 200px;
            }
        }
    }

    /deep/ .el-form-item__label {
        padding-left: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .data-picker {
        width: calc(95% - 15px) !important;

        /deep/ input {
            background-image: none;
        }

        /deep/ .el-range-separator {
            width: 30px;
        }
    }

    /deep/ .el-select__tags {
        .el-select__input {
            &:focus {
                border-color: transparent !important;
            }
        }
    }
</style>
